/**
 * useFeedbackSubmitPort — port-factory hook returning a stable
 * {@link FeedbackSubmitPort} adapter for production composition (033 US5, T040).
 *
 * The composer (`Composition`) calls this once at the root and passes the
 * instance through `PortsProvider` as the `feedbackSubmit` slot. Constructs the
 * REAL tRPC-backed adapter (`TrpcFeedbackSubmitAdapter` over
 * `member.feedback.submit`) — the member's cookie session authenticates the
 * same-origin request, so no bearer source is wired.
 *
 * Test harnesses (`renderAppWithPorts`) deliberately do NOT call this factory —
 * the slot stays omitted by default; `useSubmitFeedback` tolerates the absence
 * (the feedback tab is global chrome), so unrelated suites keep rendering.
 *
 * Owned by feature 033-data-ownership-and-lifecycle-foundations.
 */

import { useState } from 'react';

import type { FeedbackSubmitPort } from '../feedback/FeedbackSubmitPort.js';
import { TrpcFeedbackSubmitAdapter } from '../feedback/TrpcFeedbackSubmitAdapter.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useFeedbackSubmitPort(): FeedbackSubmitPort {
  const [port] = useState<FeedbackSubmitPort>(
    () => new TrpcFeedbackSubmitAdapter(createWebTrpcClient()),
  );
  return port;
}
